import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import JustValidate from 'just-validate';
import {resetErrMessages, removeErrFromValidItems} from '../includes/utils';

export function CsfPivotalFournisseurDelegationModal({
                                                       editDelegation,
                                                       contactData,
                                                       updateContactData,
                                                       handleCreateEditDelegation,
                                                       isError,
                                                       ipfErrorMat
                                                     }) {

  const [validator, setValidator] = useState(null);

  /*
  * Setup form validation
  * */
  useEffect(() => {
    const validator = new JustValidate('#delegationModal');

    validator
      .addField('#First_Name', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])
      .addField('#Last_Name', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])
      .addField('#Email', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
        {
          rule: 'email',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.email'),
        },
      ])
    setValidator(validator);

    return () => validator.destroy();
  }, []);

  function handleOnChangeValues(event) {
    let eventValue = event.target.value;
    if (event.target.type === 'checkbox') {
      eventValue = event.target.checked;
    }
    updateContactData({...contactData, [event.target.name]: eventValue});
  }

  function createEditDelegation(e) {
    e.preventDefault()

    if (validator) {
      validator.validate();
      setTimeout(() => {
        if (validator?.isValid) {
          handleCreateEditDelegation()
        } else {
          console.error('Form validation failed!');
        }
      });
    }
  }

  /*
  * Reset validation when data is prefil
  * */
  useEffect(() => {
    removeErrFromValidItems();
  }, [contactData]);

  return (
    <div className="modal fade" id="delegationModal" tabIndex="-1" role="dialog" aria-labelledby="delegationModalTitle"
         aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="delegationModalTitle">
              {editDelegation !== '' ? (
                window.Drupal.t('fournisseur.delegation.modal.edit.title')
              ) : (
                window.Drupal.t('fournisseur.delegation.modal.create.title')
              )}
            </h2>
            <button type="button" className="close" data-dismiss="modal"
                    aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <form id="createEditDelegation" method="post" onSubmit={createEditDelegation}>
            <div className="modal-body">
              {isError === true && (
                <div className="alert alert-danger" role="alert"
                     aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
              )}

              <fieldset>
                <legend
                  className="sr-only">{window.Drupal.t('fournisseur.gestion.table.firstname')} {window.Drupal.t('fournisseur.gestion.table.lastname')}</legend>
                <div className="row">
                  <div className="col-12 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="First_Name">{window.Drupal.t('fournisseur.gestion.table.firstname')}*</label>
                      <input onChange={handleOnChangeValues} value={contactData['First_Name']}
                             type="text" id="First_Name" name="First_Name"/>
                    </div>
                  </div>
                  <div className="col-12 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="Last_Name">{window.Drupal.t('fournisseur.gestion.table.lastname')}*</label>
                      <input onChange={handleOnChangeValues} value={contactData['Last_Name']}
                             type="text" id="Last_Name" name="Last_Name"/>
                    </div>
                  </div>
                  <div className="col-12 col-xl-4">
                    <div className="form-group">
                      <label
                        htmlFor="GSFT_Status_Id">{window.Drupal.t('fournisseur.gestion.status.label')}</label>
                      <select onChange={handleOnChangeValues} value={contactData['GSFT_Status_Id']}
                              id="GSFT_Status_Id" name="GSFT_Status_Id">
                        <option value="AAAAAAAAADg=">{window.Drupal.t('fournisseur.gestion.status.actif')}</option>
                        <option value="AAAAAAAAAEg=">{window.Drupal.t('fournisseur.gestion.status.inactif')}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </fieldset>

              <div className="row">
                <div className="col-12 col-xl-5">
                  <div className="form-group">
                    <label htmlFor="Email">{window.Drupal.t('fournisseur.gestion.table.email')}*</label>
                    <input onChange={handleOnChangeValues} value={contactData['Email']}
                           type="text" id="Email" name="Email"/>
                  </div>
                </div>
                <div className="col-12 col-xl-4">
                  <div className="form-group">
                    <label
                      htmlFor="IPF_Matricule_Bridge">{window.Drupal.t('fournisseur.gestion.table.matricule')}</label>
                    <input
                      onChange={handleOnChangeValues}
                      value={contactData['IPF_Matricule_Bridge']}
                      type="text"
                      id="IPF_Matricule_Bridge"
                      name="IPF_Matricule_Bridge"
                      className={ipfErrorMat ? 'custom-error-field' : ''}/>
                      { ipfErrorMat && (
                        <div className="custom-error-label" style={{color: "rgb(184, 17, 17)"}}>
                          {window.Drupal.t('fournisseur.creation_form.form.ipf.error_mat')}
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-12 col-xl-3">
                  <div className="form-group">
                    <label
                      htmlFor="GSFT_Correspondence_Language">{window.Drupal.t('fournisseur.gestion.language.label')}</label>
                    <select onChange={handleOnChangeValues} value={contactData['GSFT_Correspondence_Language']}
                            id="GSFT_Correspondence_Language" name="GSFT_Correspondence_Language">
                      <option value="0">{window.Drupal.t('broker.preferred.language.option.french')}</option>
                      <option value="1">{window.Drupal.t('broker.preferred.language.option.english')}</option>
                    </select>
                  </div>
                </div>


              </div>

              <fieldset className="mt-3">
                <legend>{window.Drupal.t('fournisseur.delegation_modal.role.label')}</legend>
                <div className="form-group special-padding d-flex align-items-center">
                  <input type="radio" id="EP_Contact_Role1" name="EP_Contact_Role" onChange={handleOnChangeValues}
                         checked={contactData['EP_Contact_Role'] == 0} value="0"/>
                  <label htmlFor="EP_Contact_Role1"><span
                    className="title">{window.Drupal.t('fournisseur.delegation.modal.responsible.label')}</span>{window.Drupal.t('fournisseur.delegation.modal.responsible.description')}
                  </label>
                </div>
                <div className="form-group special-padding d-flex align-items-center">
                  <input type="radio" id="EP_Contact_Role2" name="EP_Contact_Role" onChange={handleOnChangeValues}
                         checked={contactData['EP_Contact_Role'] == 1} value="1"/>
                  <label htmlFor="EP_Contact_Role2"><span
                    className="title">{window.Drupal.t('fournisseur.delegation.modal.designer.label')}</span>{window.Drupal.t('fournisseur.delegation.modal.designer.description')}
                  </label>
                </div>
              </fieldset>
            </div>

            <div className="modal-footer justify-content-end">
              <input
                className="button btn-submit btn-larger"
                type="submit"
                value={
                  editDelegation !== ''
                    ? window.Drupal.t('fournisseur.delegation.modal.edit.submit')
                    : window.Drupal.t('fournisseur.delegation.modal.create.submit')
                }
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurDelegationModal.propTypes = {
  editDelegation: PropTypes.string,
  contactData: PropTypes.object,
  updateContactData: PropTypes.func,
  handleCreateEditDelegation: PropTypes.func,
  isError: PropTypes.bool,
  ipfErrorMat: PropTypes.bool
};
